import React from 'react';
import type { ServiceRequestStatus } from '../../types/serviceRequestListType';
import { STATUS_CONFIG } from './viewServiceRequestHelpers';

interface SectionCardProps {
  title: string;
  children: React.ReactNode;
  testId?: string;
  className?: string;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  children,
  testId,
  className,
}) => (
  <div
    className={`border border-[#DCDDE0] rounded-[8px] p-5 flex flex-col gap-4${
      className ? ` ${className}` : ''
    }`}
    data-testid={testId}
  >
    <p className="text-titleDefault font-medium text-on-surface-variant">
      {title}
    </p>
    {children}
  </div>
);

interface InfoFieldProps {
  label: string;
  value: string;
  testId?: string;
}

export const InfoField: React.FC<InfoFieldProps> = ({
  label,
  value,
  testId,
}) => (
  <div className="flex min-w-0 flex-col gap-2">
    <p
      className="text-bodySmall font-normal text-on-surface-variant"
      data-testid={testId}
    >
      {label}
    </p>
    <p
      className="min-w-0 break-words text-bodyLarge font-normal text-neutral-10"
      data-testid={testId ? `${testId}-value` : undefined}
    >
      {value}
    </p>
  </div>
);

interface SRStatusBadgeProps {
  status: ServiceRequestStatus;
}

export const SRStatusBadge: React.FC<SRStatusBadgeProps> = ({ status }) => {
  const cfg = STATUS_CONFIG[status];
  if (!cfg) {
    return null;
  }
  return (
    <span
      className="inline-flex items-center gap-2 pl-2 pr-[10px] py-1 rounded-[8px] text-sm font-medium overflow-hidden"
      style={{
        backgroundColor: cfg.bg,
        color: cfg.text,
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: '0.1px',
      }}
      data-testid={`view-sr-status-${status}`}
    >
      <span
        className="rounded-full shrink-0"
        style={{ width: 6, height: 6, backgroundColor: cfg.text }}
      />
      <span className="wrap-break-word">{cfg.label}</span>
    </span>
  );
};

interface EmptyTabStateProps {
  title: string;
  description: string;
  testId?: string;
}

export const EmptyTabState: React.FC<EmptyTabStateProps> = ({
  title,
  description,
  testId,
}) => (
  <div
    className="flex flex-1 flex-col items-center justify-center text-center min-h-[200px]"
    data-testid={testId}
  >
    <p className="text-bodyLarge font-medium text-[#474A4C]">{title}</p>
    <p className="text-bodyMedium text-on-surface-variant mt-2 max-w-md">
      {description}
    </p>
  </div>
);
